import { apiGet, apiPatch } from './client';
import type { BaseAssetType, BaseAssetTypeBatchRequest } from '../types/BaseAssetType';

export function getBaseAssetTypes(): Promise<BaseAssetType[]> { return apiGet<BaseAssetType[]>('/api/base-asset-types'); }

export function saveBatchBaseAssetTypes(added: BaseAssetType[], modified: BaseAssetType[], deletedIds: number[]): Promise<BaseAssetType[]> {
  return apiPatch<BaseAssetTypeBatchRequest, BaseAssetType[]>('/api/base-asset-types/batch', { added, modified, deleted: deletedIds });
}
